(function( $ ) {

// Render maps on page load.
    $(document).ready(function(){
        function decodeHtmlEntities(str) {
            const textarea = document.createElement('textarea');
            textarea.innerHTML = str;
            return textarea.value;
        }
        $('#downloadModal').on('shown.bs.modal', function (e) {
            if ( $('#analystreportForm').length > 0 ) {
                irisValidation($('#analyst-report_form'), {
                    focusFirstInput: false,
                    validators: {
                      firstname: 'firstName',
                      lastname: 'lastName',
                      email: 'email',
                      company: 'companyName',
                    },
                    filters: {
                      utm_source: 'utm_param',
                      utm_campaign: 'utm_param',
                      utm_medium: 'utm_param',
                      conversion_url: 'page_url',
                      utm_gclid: 'utm_param',
                      utm_term: 'utm_param',
                      utm_content: 'utm_param',
                      pagename: 'page_url',
                      whitepaper: 'utm_param',
                      honeypot: 'utm_param',
                    },
                    validateByTimeout: ['email'],
                    errorMessages: {
                      required: 'This field is required',
                      emailFormat: 'Not a valid email',
                      connectionError: 'Server connection error. Please try again later.', // Text of error when we have some connection errors
                    },
                    success: function (data) {
                      var currentForm = $('#analyst-report_form').data('irisFormValidator');
                      console.log(data);
                      $('#analystreportForm').hide();
                      if(data['wpResult']) {
                      //  $('#thank-you-analyst-report').html(data['wpResult']);
                      }
                      $('#thank-you-analyst-report').show();
                    }
                  });
            }
        });

        setTimeout(function () {
          if (typeof (window.OneTrust) !== 'undefined') {
            //$('input[name="country"]').attr('value', window.OneTrust.getGeolocationData()['country']);
            $country_geo = window.OneTrust.getGeolocationData()['country'];
            console.log(window.OneTrust.getGeolocationData()['country']);
          } else {
            console.log('onetrust not found'); 
            $country_geo = 'us';
          }

          const phoneInputField = document.querySelector("#phone_number");
             const phoneInput = window.intlTelInput(phoneInputField, { 
              initialCountry:  $country_geo,
              formatOnDisplay: true,
              separateDialCode:false,
              countrySearch:false,
              strictMode:true, 
              customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
                return "e.g." + selectedCountryPlaceholder;
              }
          });

          const input = phoneInputField;
          const errorMsg = document.querySelector("#error-msg");

          // here, the index maps to the error code returned from getValidationError - see readme
          const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];

          const reset = () => {
            phoneInputField.classList.remove("error");
            errorMsg.innerHTML = "";
            errorMsg.classList.add("hide");
          };

          const showError = (msg) => {
            phoneInputField.classList.add("error");
            errorMsg.innerHTML = msg;
            errorMsg.classList.remove("hide");
          };

          const validatePhone = () => {
            reset();
            if (!input.value.trim()) {
              showError("Required");
            } else if (phoneInput.isValidNumberPrecise()) {
              //validMsg.classList.remove("hide");
              $('input[name="country"]').attr('value', phoneInput.getSelectedCountryData()['iso2']);
              $('input[name="phone"]').attr('value', phoneInput.getNumber());
            } else {
              const errorCode = phoneInput.getValidationError();
              const msg = errorMap[errorCode] || "Invalid number";
              showError(msg);
            }
    };

          phoneInputField.addEventListener('change', validatePhone);
          // Re-validate when the user picks a different country from the flag
          // dropdown, otherwise a stale error (e.g. "Too long") from the previous

          // country selection keeps showing even after switching to the correct one.
          phoneInputField.addEventListener('countrychange', () => {
            if (input.value.trim()) {
              validatePhone();
            } else {
              reset();
            }            
          });

        }, 1000);
    });

    $('iframe').on('load', function (){
        $("#formWrap").animate({scrollTop:0},200);
    })

})(jQuery);
